export const ACCIDENTALS = ['b♮#']

export const DEGREE_NAMES = [[], [], [], []]
DEGREE_NAMES[0] = ['C', 'C#', 'D', 'D#', 'E',
  'F', 'F#', 'G', 'G#', 'A', 'A#', 'B']
DEGREE_NAMES[1] = ['C', 'Db', 'D', 'Eb', 'E',
  'F', 'Gb', 'G', 'Ab', 'A', 'Bb', 'B']
DEGREE_NAMES[2] = ['I', 'II#', 'II', 'II#', 'III',
  'IV', 'IV#', 'V', 'V#', 'VI', 'VI#', 'VII']
DEGREE_NAMES[3] = ['I', 'IIb', 'II', 'IIIb', 'III',
  'IV', 'Vb', 'V', 'VIb', 'VI', 'VIIb', 'VII']

export const KEY_LIST = [[], []]
KEY_LIST[0] = ['G', 'D', 'A', 'E', 'B', 'F#', 'C#']
KEY_LIST[1] = ['F', 'Bb', 'Eb', 'Ab', 'Db', 'Gb', 'Cb']

export const NATURAL_SCALES = {
  Gb: ['Cb', 'Db', 'Eb', 'F', 'Gb', 'Ab', 'Bb'],
  Db: ['C', 'Db', 'Eb', 'F', 'Gb', 'Ab', 'Bb'],
  Ab: ['C', 'Db', 'Eb', 'F', 'G', 'Ab', 'Bb'],
  Eb: ['C', 'D', 'Eb', 'F', 'G', 'Ab', 'Bb'],
  Bb: ['C', 'D', 'Eb', 'F', 'G', 'A', 'Bb'],
  F: ['C', 'D', 'E', 'F', 'G', 'A', 'Bb'],
  C: ['C', 'D', 'E', 'F', 'G', 'A', 'B'],
  G: ['C', 'D', 'E', 'F#', 'G', 'A', 'B'],
  D: ['C#', 'D', 'E', 'F#', 'G', 'A', 'B'],
  A: ['C#', 'D', 'E', 'F#', 'G#', 'A', 'B'],
  E: ['C#', 'D#', 'E', 'F#', 'G#', 'A', 'B'],
  B: ['C#', 'D#', 'E', 'F#', 'G#', 'A#', 'B'],
  'F#': ['C#', 'D#', 'E#', 'F#', 'G#', 'A#', 'B']
}

export const DEFAULT_KEY = 'C'
export const KEY_NAME = DEFAULT_KEY
export const USE_ROMAN_STYLE = false
export const IS_SHARP_KEY = false

export const PITCH_INDEX = {
  Cbb: -2,
  Cb: -1,
  C: 0,
  'C#': 1,
  Cx: 2,
  Db: 1,
  Dbb: 0,
  D: 2,
  'D#': 3,
  Dx: 4,
  Ebb: 2,
  Eb: 3,
  E: 4,
  'E#': 5,
  Fb: 4,
  F: 5,
  'F#': 6,
  Fx: 7,
  Gbb: 5,
  Gb: 6,
  G: 7,
  'G#': 8,
  Gx: 9,
  Abb: 7,
  Ab: 8,
  A: 9,
  'A#': 10,
  Ax: 11,
  Bbb: 9,
  Bb: 10,
  B: 11,
  'B#': 12,
  Bx: 13
}

export const INTERVALS = ['unison', 'm2', 'M2', 'm3', 'M3', 'Perfect 4th',
  'Tritone', 'Perfect 5th', 'm6', 'M6', 'm7', 'M7']

export const INTERVAL_SIZE = {
  U1: 0,
  m2: 1,
  m9: 1,
  d9: 1,
  M2: 2,
  M9: 2,
  A9: 3,
  A2: 3,
  m3: 3,
  M3: 4,
  d4: 4,
  P4: 5,
  P11: 5,
  A4: 6,
  A11: 6,
  TT: 6,
  d5: 6,
  P5: 7,
  A5: 8,
  m6: 8,
  m13: 8,
  M13: 9,
  M6: 9,
  A6: 10,
  d7: 9,
  m7: 10,
  M7: 11
}

export const CHORD_DATA = {
  // Intervals
  // U1: 'note(s)',
  'U1,P5': '5',
  // 'U1,m2': 'minor 2nd(9th)',
  // 'U1,M2': 'Major 2nd(9th)',
  // 'U1,m3': 'minor 3rd',
  // 'U1,M3': 'Major 3rd',
  // 'U1,P4': 'Perfect 4th',
  // 'U1,A4': 'Tritone',
  // // 'U1,P5': 'Perfect 5th',
  // 'U1,m6': 'minor 6th(13th)',
  // 'U1,M6': 'Major 6th(13th)',
  // 'U1,m7': 'minor 7th',
  // 'U1,M7': 'Major 7th',

  // Chords:
  'U1,M3,P5': '', // empty for 'Major triad'
  'U1,m3,P5': 'm',
  'U1,M3,A5': '+',
  'U1,m3,d5': 'dim',
  'U1,A4,P5': 'lyd',
  'U1,m2,P5': 'phry',
  'U1,M3,P5,M6': '6',
  'U1,M9,M3,P5,M6': '69',
  'U1,M9,M3,M6': '69 no5',
  'U1,m3,P5,M6': 'm6',
  'U1,m3,P5,M6,M9': 'm69',
  'U1,m3,M6,M9': 'm69 no5',
  'U1,M3,d5': 'b5',
  'U1,P4,P5': 'sus4',
  'U1,M9,P5': 'sus2',
  'U1,P4,P5,m7': '7sus4',
  'U1,M9,P4,P5,m7': '9sus4',
  'U1,M3,P5,P11': 'add11',
  'U1,m3,P5,P11': 'm add11',
  'U1,M3,P5,M9': 'add9',
  'U1,M3,P5,m9': 'b9',
  'U1,m3,P5,M9': 'madd9',
  'U1,m3,d5,P11': 'dim (11)',
  'U1,m3,d5,M9': 'dimM9',
  'U1,m3,P5,M9,P11': 'm11 no 7',
  'U1,P5,M7,M9': 'Maj7 sus2',
  'U1,P5,M7,P4': 'Maj7 sus4',
  'U1,P5,M7,P4,M9': 'Maj9 sus4',
  // Major
  'U1,M3,P5,M7': 'Maj7',
  'U1,M3,M7': 'Maj7 no5',
  'U1,M3,A5,M7': 'Maj7+5',
  'U1,M3,M7,A11,M13': 'Maj7 b5 (13)',
  'U1,M3,M7,A11': 'Maj7b5',
  'U1,M3,M7,M13': 'Maj7 (13) no5',
  'U1,M3,M7,M9,A11,M13': 'Maj13 no5',
  'U1,M3,M7,M9,A11': 'Maj11 no5',
  'U1,M3,M7,M9,M13': 'Maj9 (13) no5',
  'U1,M3,M7,M9': 'Maj9 no5',
  'U1,M3,P5,M7,A11,M13': 'Maj7 (#11, 13)',
  'U1,M3,P5,M7,A11': 'Maj7 (#11)',
  'U1,M3,P5,M7,M13': 'Maj7 (13)',
  'U1,M3,P5,M7,m13': 'Maj7 (b13)',
  'U1,M3,P5,M7,M9,A11': 'Maj11',
  'U1,M3,P5,M7,M9,M13': 'Maj9 (13)',
  'U1,M3,P5,M7,m9': 'Maj7 (b9)',
  'U1,M3,P5,M7,M9': 'Maj9',
  // Minor7
  // 'U1,m3,A5,m7,A9,A11,M13']), 'm13#5#9#11' ,
  // 'U1,m3,A5,m7,A9,P11,M13']), 'm13#5#9' ,
  // 'U1,m3,A5,m7,A9,P11']), 'm11#5#9' ,
  // 'U1,m3,A5,m7,M9,A11,M13']), 'm13#5#11' ,
  // 'U1,m3,A5,m7,M9,P11,M13']), 'm13#5' ,
  // 'U1,m3,A5,m7,m9,A11,M13']), 'm13#5b9#11' ,
  // 'U1,m3,A5,m7,m9,P11,M13']), 'm13#5b9' ,
  // 'U1,m3,A5', m7]), 'm7#5' ,
  // 'U1,m3,d5,m7,A9,P11,M13']), 'm13b5#9' ,
  // 'U1,m3,m7,A5', m9]), 'm7#5b9' ,
  // 'U1,m3,m7,m9,A11,M13']), 'm13b5b9' ,
  // 'U1,m3,m7,m9,P11,M13']), 'm13b9 no5' ,
  'U1,m3,P5,m7': 'm7',
  'U1,m3,m7,d5': 'm7b5', // no '()'
  'U1,m3,P5,m7,A11': 'm7 (#11)',
  'U1,m3,P5,m7,M13': 'm7 (13)',
  'U1,m3,P5,m7,m9': 'm7 (b9)',
  'U1,m3,P5,m7,P11,M13': 'm7 (11, 13)',
  'U1,m3,P5,m7,P11': 'm7 (11)',
  'U1,m3,m7,P11': 'm7 (11) no5',
  'U1,m3,m7': 'm7 no5',
  'U1,m3,m7,M13': 'm7 (13) no5',
  'U1,m3,m7,m9': 'm7b9 no5',
  'U1,m3,m7,P11,M13': 'm7 (11, 13) no5',

  'U1,m3,A5,m7,M9': 'm9#5',
  'U1,m3,P5,m7,M9,M13': 'm9 (13)',
  'U1,m3,P5,m7,M9': 'm9',
  'U1,m3,d5,d7': 'dim7',
  'U1,m3,d5,m7,M9': 'm9b5',
  'U1,m3,m7,A11,m9': 'm7b5b9',
  'U1,m3,m7,M9,M13': 'm9 (13) no5',
  'U1,m3,m7,M9': 'm9 no5',

  'U1,m3,A5,m7,M9,P11': 'm11#5', // for modes like Dorian/Aeolian
  'U1,m3,A5,m7,m9,P11': 'm11#5b9',
  'U1,m3,P5,m7,M9,P11': 'm11',
  'U1,m3,P5,m7,m9,P11': 'm11b9',
  'U1,m3,d5,m7,A9,P11': 'm11b5#9',
  'U1,m3,d5,m7,M9,P11': 'm11b5',
  'U1,m3,d5,m7,m9,P11': 'm11b5b9',
  'U1,m3,m7,M9,P11': 'm11 no5',
  'U1,m3,m7,M9,P11,M13': 'm13 (Dorian) no5',
  'U1,m3,P5,m7,M9,P11,M13': 'm13',

  // Dominant
  'U1,M3,A5,m7,m9,P11': '11#5b9',
  'U1,M3,d5,m7,m9,P11': '11b5b9',
  'U1,M3,A5,m7,M9,P11': '11#5',
  'U1,M3,d5,m7,M9,P11': '11b5',
  'U1,M3,A5,m7,A9,A11,M13': '13#5#9#11',
  'U1,M3,A5,m7,A9,P11,M13': '13#5#9',
  'U1,M3,A5,m7,M9,A11,M13': '13#5#11',
  'U1,M3,A5,m7,m9,A11,M13': '13#5b9#11',
  'U1,M3,A5,m7,M9,P11,M13': '13#5',
  'U1,M3,A5,m7,m9,P11,M13': '13#5b9',
  'U1,M3,d5,m7,A9,P11,M13': '13b5#9',
  'U1,M3,d5,m7,M9,P11,M13': '13b5',
  'U1,M3,m7,A11,A5,A9': '7b5#5#9',
  'U1,M3,m7,A11,A5,m9': '7b5#5b9',
  'U1,M3,m7,A11,A9': '7b5#9',
  'U1,M3,m7,A11,m9,A9': '7b5b9#9',
  'U1,M3,m7,A11,m9': '7b5b9',
  'U1,M3,m7,A11': '7b5',
  'U1,M3,m7,A5,A9': '7#5#9',
  'U1,M3,m7,A5,m9,A9': '7#5b9#9',
  'U1,M3,m7,A5,m9': '7#5b9',
  'U1,M3,m7,A5': '7#5',
  'U1,M3,m7,m9,d5,M13': '13b5b9',
  'U1,M3,P5,m7,M9': '9',
  'U1,M3,m7,M9': '9 no5',
  'U1,M3,P5,m7,M9,A11': '9#11',
  'U1,M3,d5,m7,M9': '9b5',
  'U1,M3,A5,m7,M9': '9#5',
  'U1,M3,A5,m7,M9,A11': '9#5#11',
  'U1,M3,P5,m7,M9,M6': '9 (13)',
  'U1,M3,m7,M9,M6': '9 (13) no5',
  'U1,M3,P5,m7,M9,m6': '9b13',
  'U1,M3,m7,M9,m6': '9b13 no5',
  'U1,M3,P5,m7,M9,P11': '11',
  'U1,M3,m7,M9,P11': '11 no5',
  'U1,M3,P5,m7,A9,P11': '11#9',
  'U1,M3,m7,A9,P11': '11#9 no5',
  'U1,M3,A5,m7,A9,P11': '11#5#9',
  'U1,M3,d5,m7,A9,P11': '11b5#9',
  'U1,M3,P5,m7,m9,P11': '11b9',
  'U1,M3,m7,m9,P11': '11b9 no5',
  'U1,M3,P5,m7,A11': '7#11',
  'U1,M3,P5,m7,A5': '7b13',
  'U1,M3,P5,m7,A9,A11,M13': '13#9#11',
  'U1,M3,m7,A9,A11,M13': '13#9b5',
  'U1,M3,P5,m7,A9,A11': '7#9#11',
  'U1,M3,m7,A9,A11': '7#9b5',
  'U1,M3,P5,m7,A9,P11,M13': '13#9',
  'U1,M3,m7,A9,P11,M13': '13#9 no5',
  'U1,M3,P5,m7,A9': '7#9',
  'U1,M3,m7,A9': '7#9 no5',
  'U1,M3,P5,m7,M13': '7 (13)',
  'U1,M3,m7,M13': '7 (13) no5',
  'U1,M3,P5,m7,m9,A11,M13': '13b9#11',
  'U1,M3,m7,m9,A11,M13': '13b9b5',
  'U1,M3,P5,m7,m9,A11': '7b9#11',
  'U1,M3,m7,m9,A11': '7b9b5',
  'U1,M3,P5,m7,M9,M13': '7 (9, 13)',
  'U1,M3,P5,m7,m9,M13': '7 (b9, 13)',
  'U1,M3,m7,M9,M13': '7 (9, 13) no5',
  'U1,M3,m7,m9,M13': '7 (b9, 13) no5',
  'U1,P5,m7,M9,P11,M13': '13 sus4',
  'U1,m7,M9,P11,M13': '13 sus4 no5',
  'U1,M3,m7,M9,P11,M13': '13 no5',
  'U1,M3,P5,m7,m9,P11,M13': '13b9',
  'U1,M3,m7,m9,P11,M13': '13b9 no5',
  'U1,M3,P5,m7,m9': '7b9',
  'U1,M3,m7,m9': '7b9 no5',
  'U1,M3,P5,m7,P11,M13': '7 (11,13)',
  'U1,M3,m7,P11,M13': '7 (11,13) no5',
  'U1,M3,P5,m7,P11': '7 (11)',
  'U1,M3,m7,P11': '7 (11) no5',
  'U1,M3,P5,m7': '7',
  'U1,M3,m7': '7no5',
  // 'U1,M3,m7': '7 no5' ,
  // Minor Major7
  'U1,m3,d5,M7': 'dimMaj7',
  'U1,m3,M7,A11,m9': 'mMaj7b5b9',
  'U1,m3,P5,M7,A11': 'mMaj7#11',
  'U1,m3,M7,A11': 'mMaj7b5',
  'U1,m3,P5,M7,A5': 'mMaj7b13',
  'U1,m3,M7,A5': 'mMaj7#5',
  'U1,m3,P5,M7,M9,M13': 'mMaj9 (13)',
  'U1,m3,M7,M9,M13': 'mMaj9 (13) no5',
  // ('U1,m3,P5,M7', m9]), 'mMaj7b9' ,
  // ('U1,m3,M7', m9]), 'mMaj7b9 no5' ,
  'U1,m3,P5,M7,M9': 'mMaj9',
  'U1,m3,M7,M9': 'mMaj9 no5',
  'U1,m3,P5,M7': 'mMaj7',
  'U1,m3,M7': 'mMaj7 no5',
  // below are the scales

  // 'U1,M2,M3,P4,P5,M6,M7': 'Ionian (Maj7)',
  // 'U1,m3,P5,m7,M9,P11,M13': 'm13 (Dorian) (m6add9)',
  // 'U1,m2,m3,P4,P5,m6,m7': 'Phrygian (m7)',
  'U1,M3,P5,M7,M9,A11,M13': 'Maj13',
  'U1,M3,P5,m7,M9,P11,M13': '13'
  // 'U1,M2,m3,P4,P5,m6,m7': 'Aeolian (m7)',
  // 'U1,m2,m3,P4,d5,m6,m7': 'Locrian (m7b5)',
  //
  // 'U1,M2,m3,P4,P5,m6,M7': 'Harmonic Minor Scale (mMaj7)',
  // 'U1,m2,m3,P4,d5,M6,m7': 'Locrian ♮6 (m7b5)',
  // 'U1,M2,M3,P4,A5,M6,M7': 'Ionian Augmented (Maj7#5)',
  // 'U1,M2,m3,A4,P5,M6,m7': 'Dorian #4 (m7#11)',
  // 'U1,m2,M3,P4,P5,m6,m7': 'Phrygian ♮3',
  // 'U1,A2,M3,A4,P5,M6,M7': 'Lydian #9 (Maj7#9)',
  // 'U1,m2,m3,d4,d5,m6,d7': 'Altered Dominant bb7',
  //
  // 'U1,M2,m3,P4,P5,M6,M7': 'Jazz Minor Scale (mMaj7)', // mMaj7
  // 'U1,m2,m3,P4,P5,M6,m7': 'Dorian b2 (b9sus4)', // b9sus4
  // 'U1,M2,M3,A4,A5,M6,M7': 'Lydian Augmented (Maj7#5#11)', // Maj7#5
  // 'U1,M2,M3,A4,P5,M6,m7': 'Lydian Dominant (7#11)', // 7#11
  // 'U1,M2,M3,P4,P5,m6,m7': 'Mixolydian b6 (7b13)', // 7b13
  // 'U1,M2,m3,P4,d5,m6,m7': 'Locrian ♮2 (m7b5)', // m7b5
  // 'U1,M3,m7,A11,A5,m9,A9': 'Altered Scale',
  //
  // 'U1,M2,M3,P5,M6': 'Major Pentatonic Scale',
  // 'U1,m3,P4,P5,m7': 'Minor Pentatonic Scale',
  // 'U1,M2,M3,A4,A5,A6': 'Whole Tone Scale',
  // 'U1,A2,M3,P5,A5,M7': 'Augmented Scale',
  // 'U1,M2,m3,M3,P5,M6': 'Major Blues Scale',
  // 'U1,m3,P4,A4,P5,m7': 'Minor Blues Scale',
  // 'U1,M2,m3,P4,A4,A5,M6,M7': 'WH Diminished Scale',
  // 'U1,m2,m3,M3,A4,P5,M6,m7': 'HW Diminished Scale',
  // 'U1,M2,m3,M3,P5,M6,m7,M7': 'Dominant Diminished Scale',
  //
  // 'U1,M2,M3,P4,P5,M6,m7,M7': 'Dominant Bebop Scale',
  // 'U1,M2,M3,P4,P5,m6,M6,M7': 'Major Bebop Scale',
  // 'U1,M2,m3,P4,P5,M6,m7,M7': 'minor Bebop Scale'
}
